import * as max from '../max-length-validators';
import * as required from '../required-validators';

export default {
  name: 'streetName',
  label: 'checkout.address.field.label.address1.text',
  required: true,
  maxLength: 35,
  validate: [required.address1, max.lengthAddress(35)],
};
